import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

export function EmptyState({
  title,
  description,
  action,
  icon: Icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  /** Optional: a line icon for what is missing (FileText for invoices, and so on). */
  icon?: LucideIcon;
}) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-input bg-card px-6 py-12 text-center">
      {Icon && (
        <span className="mb-1 flex h-11 w-11 items-center justify-center rounded-full bg-accent text-primary">
          <Icon className="h-5 w-5" aria-hidden />
        </span>
      )}
      <p className="font-display text-lg font-semibold text-foreground">{title}</p>
      {description && <p className="max-w-md text-sm text-muted-foreground">{description}</p>}
      {action && <div className="pt-3">{action}</div>}
    </div>
  );
}
